
    <div>
      <div *ngIf="params.checkboxSelection">
        <mat-checkbox [disableRipple]="true" (click)="selectionChanged()"></mat-checkbox>
      </div>
    </div>
  